import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { Shared } from '../shared.service';
import { Router } from '@angular/router';
import 'rxjs/Rx';

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.scss']
})
export class ControlComponent implements OnInit {

  locations_list;
  products_list;
  settings_object;


  constructor(public shared: Shared, private db: AngularFireDatabase, private router: Router) {
     shared.getInfo();
  }

  toggleSwitch(){
      this.shared.switchActive = !this.shared.switchActive;
  }

  ngOnInit() {
  }

  logout(){
      this.shared.afAuth.auth.signOut();
  }

  isTab(tab){
      return this.shared.control_tab === tab;
  }

  closeMenu(){
      this.shared.mobile_menu = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/control/control.component.ts